// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Function_Uncurried = require("../Data.Function.Uncurried/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Query = require("../Halogen.Query/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Data_Editor_Node_NodeId = require("../Lunarbox.Data.Editor.Node.NodeId/index.js");
var Web_HTML_HTMLCanvasElement = require("../Web.HTML.HTMLCanvasElement/index.js");
var CreateConnection = (function () {
    function CreateConnection(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    CreateConnection.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new CreateConnection(value0, value1, value2);
            };
        };
    };
    return CreateConnection;
})();
var SelectInput = (function () {
    function SelectInput(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SelectInput.create = function (value0) {
        return function (value1) {
            return new SelectInput(value0, value1);
        };
    };
    return SelectInput;
})();
var SelectOutput = (function () {
    function SelectOutput(value0) {
        this.value0 = value0;
    };
    SelectOutput.create = function (value0) {
        return new SelectOutput(value0);
    };
    return SelectOutput;
})();
var DeleteConnection = (function () {
    function DeleteConnection(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DeleteConnection.create = function (value0) {
        return function (value1) {
            return new DeleteConnection(value0, value1);
        };
    };
    return DeleteConnection;
})();
var EditNode = (function () {
    function EditNode(value0) {
        this.value0 = value0;
    };
    EditNode.create = function (value0) {
        return new EditNode(value0);
    };
    return EditNode;
})();
var Goto = (function () {
    function Goto(value0) {
        this.value0 = value0;
    };
    Goto.create = function (value0) {
        return new Goto(value0);
    };
    return Goto;
})();
var NoAction = (function () {
    function NoAction() {

    };
    NoAction.value = new NoAction();
    return NoAction;
})();
var ForeignActionConfig = function (x) {
    return x;
};
var withContext = function (dictMonadEffect) {
    return function (ref) {
        return function ($$continue) {
            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                return v.context;
            }))(function (context) {
                if (context instanceof Data_Maybe.Just) {
                    return $$continue(context.value0);
                };
                if (context instanceof Data_Maybe.Nothing) {
                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(function (v) {
                        return Control_Bind.bind(Data_Maybe.bindMaybe)(v)(Web_HTML_HTMLCanvasElement.fromHTMLElement);
                    })(Halogen_Query.getHTMLElementRef(ref)))(function (element) {
                        if (element instanceof Data_Maybe.Nothing) {
                            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                        };
                        if (element instanceof Data_Maybe.Just) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))($foreign.resizeCanvas(element.value0)))(function () {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))($foreign.getContext(element.value0)))(function (ctx) {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                                        var $18 = {};
                                        for (var $19 in v) {
                                            if ({}.hasOwnProperty.call(v, $19)) {
                                                $18[$19] = v[$19];
                                            };
                                        };
                                        $18.context = new Data_Maybe.Just(ctx);
                                        return $18;
                                    }))(function () {
                                        return $$continue(ctx);
                                    });
                                });
                            });
                        };
                        throw new Error("Failed pattern match at Lunarbox.Foreign.Render (line 143, column 7 - line 149, column 23): " + [ element.constructor.name ]);
                    });
                };
                throw new Error("Failed pattern match at Lunarbox.Foreign.Render (line 139, column 3 - line 149, column 23): " + [ context.constructor.name ]);
            });
        };
    };
};
var genericForeignAction = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof CreateConnection) {
        return new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2)));
    };
    if (x instanceof SelectInput) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)));
    };
    if (x instanceof SelectOutput) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof DeleteConnection) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))));
    };
    if (x instanceof EditNode) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
    };
    if (x instanceof Goto) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
    };
    if (x instanceof NoAction) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))));
    };
    throw new Error("Failed pattern match at Lunarbox.Foreign.Render (line 83, column 1 - line 83, column 64): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new CreateConnection(x.value0.value0, x.value0.value1.value0, x.value0.value1.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new SelectInput(x.value0.value0.value0, x.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new SelectOutput(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return new DeleteConnection(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return new EditNode(x.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return new Goto(x.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
        return NoAction.value;
    };
    throw new Error("Failed pattern match at Lunarbox.Foreign.Render (line 83, column 1 - line 83, column 64): " + [ x.constructor.name ]);
});
var showForeignAction = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericForeignAction)(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsProduct(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Editor_Node_NodeId.showNodeId))(Data_Generic_Rep_Show.genericShowArgsProduct(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Editor_Node_NodeId.showNodeId))(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showInt))))(new Data_Symbol.IsSymbol(function () {
    return "CreateConnection";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsProduct(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Editor_Node_NodeId.showNodeId))(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showInt)))(new Data_Symbol.IsSymbol(function () {
    return "SelectInput";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Editor_Node_NodeId.showNodeId))(new Data_Symbol.IsSymbol(function () {
    return "SelectOutput";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsProduct(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Editor_Node_NodeId.showNodeId))(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showInt)))(new Data_Symbol.IsSymbol(function () {
    return "DeleteConnection";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Editor_Node_NodeId.showNodeId))(new Data_Symbol.IsSymbol(function () {
    return "EditNode";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Editor_Node_NodeId.showNodeId))(new Data_Symbol.IsSymbol(function () {
    return "Goto";
})))(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "NoAction";
}))))))))));
var encodeJsonGeometryCache = new Data_Argonaut_Encode_Class.EncodeJson($foreign.geometryCacheToJson);
var defaultForeignActionConfig = new Data_Default.Default({
    createConnection: Data_Function_Uncurried.mkFn3(CreateConnection.create),
    selectInput: Data_Function_Uncurried.mkFn2(SelectInput.create),
    deleteConnection: Data_Function_Uncurried.mkFn2(DeleteConnection.create),
    selectOutput: SelectOutput.create,
    "goto": Goto.create,
    editNode: EditNode.create,
    nothing: NoAction.value
});
var handleDoubleClick = Data_Function_Uncurried.runFn4($foreign.handleDoubleClickImpl)(Data_Default.def(defaultForeignActionConfig));
var handleMouseDown = Data_Function_Uncurried.runFn4($foreign.handleMouseDownImpl)(Data_Default.def(defaultForeignActionConfig));
var handleMouseMove = Data_Function_Uncurried.runFn4($foreign.handleMouseMoveImpl)(Data_Default.def(defaultForeignActionConfig));
var handleMouseUp = Data_Function_Uncurried.runFn4($foreign.handleMouseUpImpl)(Data_Default.def(defaultForeignActionConfig));
var decodeJsonGeometryCache = new Data_Argonaut_Decode_Class.DecodeJson($foreign.geometryCacheFromJsonImpl({
    left: Data_Either.Left.create,
    right: Data_Either.Right.create
}));
module.exports = {
    CreateConnection: CreateConnection,
    SelectInput: SelectInput,
    SelectOutput: SelectOutput,
    DeleteConnection: DeleteConnection,
    EditNode: EditNode,
    Goto: Goto,
    NoAction: NoAction,
    ForeignActionConfig: ForeignActionConfig,
    handleMouseDown: handleMouseDown,
    handleMouseUp: handleMouseUp,
    handleMouseMove: handleMouseMove,
    handleDoubleClick: handleDoubleClick,
    withContext: withContext,
    decodeJsonGeometryCache: decodeJsonGeometryCache,
    encodeJsonGeometryCache: encodeJsonGeometryCache,
    genericForeignAction: genericForeignAction,
    showForeignAction: showForeignAction,
    defaultForeignActionConfig: defaultForeignActionConfig,
    resizeCanvas: $foreign.resizeCanvas,
    resizeContext: $foreign.resizeContext,
    getContext: $foreign.getContext,
    renderScene: $foreign.renderScene,
    emptyGeometryCache: $foreign.emptyGeometryCache,
    handleMouseMoveImpl: $foreign.handleMouseMoveImpl,
    handleMouseUpImpl: $foreign.handleMouseUpImpl,
    handleMouseDownImpl: $foreign.handleMouseDownImpl,
    handleDoubleClickImpl: $foreign.handleDoubleClickImpl,
    geometryCacheFromJsonImpl: $foreign.geometryCacheFromJsonImpl,
    geometryCacheToJson: $foreign.geometryCacheToJson,
    createNode: $foreign.createNode,
    refreshInputArcs: $foreign.refreshInputArcs,
    setUnconnectableInputs: $foreign.setUnconnectableInputs,
    setUnconnectableOutputs: $foreign.setUnconnectableOutputs,
    deleteNode: $foreign.deleteNode,
    renderPreview: $foreign.renderPreview,
    centerNode: $foreign.centerNode,
    centerOutput: $foreign.centerOutput
};
